import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { InternationalTribunalJobType, meetingTypes, } from '@debbie/common/dist/tribunal/jobs/types.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import { Button, File, DateInput, Input, SearchInput, Select } from '../../../index.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import q from '@debbie/cortex/dist/query.js';
import { courts, getCourtByCountryCode, } from '@debbie/common/dist/court/index.js';
import { addressToString } from '@debbie/common/dist/index.js';
import { selectTenant } from '@debbie/cortex/dist/me/selectors.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
const CourtMeeting = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const singleCase = useSelector((s) => selectCaseById(s, props.tribunalCase.caseId));
    const customer = useSelector((s) => singleCase?.customerId && selectCustomerById(s, singleCase?.customerId));
    const [loading, setLoading] = useState(false);
    const [meetingType, setMeetingType] = useState(undefined);
    const [fsNo, setFsNo] = useState(props.tribunalCase.reference || 'FS');
    const [date, setDate] = useState(moment());
    const [courtId, setCourtId] = useState(null);
    const [meetingLocation, setMeetingLocation] = useState(null);
    const [file, setFile] = useState(null);
    const dropzoneRef = useRef(null);
    useEffect(() => {
        if (customer) {
            const user = customer.users.find((u) => u.relation === 'debtor' && u.contact);
            if (user && user.details.courtId) {
                const court = user.details.courtId
                    ? courts.find((c) => c.id === user.details.courtId)
                    : undefined;
                if (court?.courtId) {
                    setCourtId(court.courtId);
                }
            }
        }
    }, [customer]);
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const uploadFile = async (acceptedFiles) => {
        for (let i = 0; i < acceptedFiles.length; i++) {
            const acceptedFile = acceptedFiles[i];
            const content = await promiseFileReader(acceptedFile);
            const { file } = await files.save({
                content: content.split('base64,')[1],
                name: acceptedFile.name,
                contentType: acceptedFile.type,
            });
            setFile(file);
        }
    };
    const addCourtMeeting = async () => {
        setLoading(true);
        try {
            if (!date) {
                throw 'Date is required';
            }
            await tribunalAPI.createTribunalJob({
                type: InternationalTribunalJobType.CourtMeeting,
                tribunalCaseId: props.tribunalCase.id,
                data: {
                    meetingTypeId: meetingType,
                    meetingDate: date.format(),
                    fileId: file?.fileId,
                    courtId,
                    meetingLocation,
                    meetingForm: null,
                },
                caseId: props.tribunalCase.caseId,
                reference: `${fsNo}`.trim(),
            });
            props.onSubmit();
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
        q.invalidate(keys.write.create(tribunalJobsEntity));
    };
    return (
    // @ts-ignore
    React.createElement(Dropzone, { style: {}, disableClick: true, ref: dropzoneRef, multiple: true, onDrop: uploadFile },
        React.createElement("h4", null, lang.tribunal.phoneCourtMeeting),
        !props.tribunalCase.reference && (React.createElement(Input, { placeholder: lang.tribunal.fsNo, value: fsNo, onChange: (e) => setFsNo(e.target.value) })),
        React.createElement(Select, { value: meetingType, label: lang.tribunal.courtMeetingType, onChange: (e) => setMeetingType(e.currentTarget.value) },
            React.createElement("option", null, "-"),
            meetingTypes
                .filter((mt) => mt.relevantCaseTypes.includes(props.tribunalCase.type))
                .map((mt) => {
                return (React.createElement("option", { key: mt.id, value: mt.id }, mt.label));
            })),
        React.createElement(DateInput, { placeholder: lang.tribunal.meetingDate, value: date, onChange: (d) => setDate(d), showTimeSelect: true, allowNull: true }),
        React.createElement(SearchInput, { placeholder: lang.debtorInfo.chooseJurisdiction, searchAll: (q) => {
                if (!tenant) {
                    return [];
                }
                return (getCourtByCountryCode(tenant?.countryCode) || [])
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.courtId,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c.courtId,
                }));
            }, static: (() => {
                const court = courtId && courts.find((c) => c.courtId === courtId);
                return court && court.name;
            })(), onRemoveStatic: () => setCourtId(null), onSelect: setCourtId, searchDelay: 0, forceOpen: true }),
        React.createElement(Input, { value: meetingLocation || undefined, placeholder: lang.tribunal.meetingLocation, onChange: (value) => setMeetingLocation(value.target.value) }),
        React.createElement(Button, { onClick: () => {
                // @ts-ignore
                dropzoneRef.current?.open();
            }, size: "small", theme: "secondary", block: true }, lang.tribunal.addDocument),
        file && (React.createElement("p", null,
            React.createElement(File, { file: file, removable: true, onRemove: () => setFile(null) }))),
        React.createElement("br", null),
        React.createElement(Button, { onClick: addCourtMeeting, loading: loading, disabled: !date, block: true }, lang.tribunal.register)));
};
export default CourtMeeting;
//# sourceMappingURL=CourtMeeting.js.map